module.exports = __webpack_public_path__ + "static/media/3.510882f9.jpg";